module.exports = __webpack_public_path__ + "static/img/buddy_pictgrid23_920x832.628471f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_pictgrid23_920x832.jpg
// module id = +SxV
// module chunks = 0